import { graphql } from "src/graphql/generated";

export const campaignReviewsQuery = graphql(/* GraphQL */ `
    query CampaignReviews(
        $campaignId: String!
        $productId: String!
        $nextToken: String
        $limit: Int
        $state: [ReviewState!]
    ) {
        campaign(campaignId: $campaignId) {
            id
            reviews(productId: $productId, limit: $limit, nextToken: $nextToken, state: $state) {
                nextToken
                items {
                    ...reviewItemFields
                }
            }
        }
    }
`);

export const reviewCommentsQuery = graphql(/* GraphQL */ `
    query ReviewComments($clientId: String!, $reviewId: String!) {
        review(clientId: $clientId, reviewId: $reviewId) {
            id
            comments {
                items {
                    sentAt
                    content
                    author {
                        id
                        userType
                        user {
                            __typename
                            ... on CognitoUser {
                                Attributes {
                                    Name
                                    Value
                                }
                            }
                            ... on ClientUser {
                                email
                                firstName
                                lastName
                            }
                        }
                    }
                }
            }
        }
    }
`);
